import Api from "../../../../shared/api/api";
import DOMPurify from "dompurify";
export const reviewStatuses = [
  {value:"researching",label:"Researching"}, {value:"approved",label:"Approved"},
  {value:"ready",label:"Ready"}, {value:"submissions_closed",label:"Book Submissions Closed"},
  {value:"rejected",label:"Rejected"}
];
export const reviewStatusLabel = value => reviewStatuses.find(s => s.value === value)?.label || value;
export function outreachBookLink(book) {
  if (!book?.title) return "";
  const fallback = `https://kennethlpowell.com/books/${encodeURIComponent(book.title)}`;
  try {
    const url = new URL(book.direct_purchase_url || fallback, "https://kennethlpowell.com");
    return ["http:","https:"].includes(url.protocol) ? url.href : fallback;
  } catch {return fallback;}
}
export function outreachBookBlurb(book) {
  const value = book?.description || "";
  if (!value.trim()) return "";
  if (/<\/?[a-z][^>]*>/i.test(value)) return DOMPurify.sanitize(value);
  const escape = text => text.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
  return value.split(/\n\s*\n/).map(p => `<p>${escape(p).replace(/\n/g,"<br>")}</p>`).join("");
}
let mutationRevision = 0;
export const outreachRevision = () => mutationRevision;
export const outreach = async (path, data = {}, method = "get") => {
  const result = await Api.request(`api/outreach/${path}`, data, method);
  if (method !== "get" && !/discovery\/search|email-preview|templates\/render|import\/preview/.test(path)) mutationRevision += 1;
  return result;
};
export function download(text, filename, type = "text/plain") {
  const url = URL.createObjectURL(new Blob([text], {
    type
  }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export function utc(value) {
  return value ? new Date(value).toISOString() : null;
}
export function localDate(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
}
export const label = value => value === "submissions_closed" ? "Submissions Closed" : String(value || "").replace(/_/g, " ");
export function reportCSV(report) {
  const rows = [["Metric", "Group", "Value"]];
  for (const [key, value] of Object.entries(report)) {
    if (Array.isArray(value)) value.forEach(row => rows.push([key, Object.entries(row).filter(([k]) => k !== "total").map(([k, v]) => `${k}: ${v}`).join("; "), row.total ?? ""]));else if (value && typeof value === "object") Object.entries(value).forEach(([field, v]) => rows.push([key, field, v ?? "Unknown"]));else rows.push([key, "", value ?? "Unknown"]);
  }
  const cell = value => {
    let text = String(value);
    if (/^[\s\u0000-\u001f]*[=+@-]/.test(text)) text = "'" + text;
    return '"' + text.replace(/"/g, '""') + '"';
  };
  return rows.map(row => row.map(cell).join(",")).join("\r\n");
}
